<template>
  <div
      class="flex shadow-md rounded-2xl px-6 py-4 text-center bg-white"
      style="min-height: 24rem;"
  >
    <div
        v-if="showContent"
        class="flex flex-col flex-grow space-y-4"
    >
      <!--Navigation-->
      <div
          v-if="showTopBar"
          class="flex justify-between items-center space-x-5"
      >
        <a-button
            v-if="options.showNav"
            type="link"
            icon="arrow-left"
            class="nav-button pointer-events-auto"
            :style="{'--accent-color': accentColor.color}"
            :disabled="!options.showBack"
            @click="$emit('prev')"
        />
        <a-progress
            v-if="options.showProgress"
            :percent="options.progress"
            :format="() => ''"
            :stroke-color="accentColor.color"
        />
        <a-button
            v-if="options.showNav"
            type="link"
            icon="stop"
            class="nav-button pointer-events-auto"
            :style="{'--accent-color': accentColor.color}"
            :disabled="!options.showSkip"
            @click="$emit('next')"
        />
      </div>

      <!--Image-->
      <div
          v-if="options.imgSrc"
          class="flex-none rounded-lg overflow-hidden"
          style="aspect-ratio: 4/3;"
      >
        <img
            :src="options.imgSrc | parseImgUrl"
            class="w-full h-full select-none pointer-events-none"
            :class="this.isVerticalImg ? 'object-contain' : 'object-cover'"
            alt="image"
            @load="onLoadImage"
        />
      </div>

      <!--Content-->
      <slot></slot>

      <!--Button-->
      <div v-if="$slots.button">
        <slot name="button"></slot>
      </div>

      <!--Branding-->
      <div
          v-if="showBranding"
          style="margin-bottom: -8px;"
          class="flex justify-center"
      >
        <BrandingLogo />
      </div>
    </div>
  </div>
</template>

<script>
import {parseImgUrl} from "../helpers/fns";
import themeMixin from "../mixins/theme.mixin";
import BrandingLogo from "./BrandingLogo.vue";
import {mapGetters} from "vuex";

export default {
  name: "CardItem",
  components: {BrandingLogo},
  props: {
    showContent: {
      type: Boolean,
      default: true
    },
    showTopBar: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
  },
  filters: {
    parseImgUrl,
  },
  mixins: [themeMixin],
  data() {
    return {
      isVerticalImg: false,
    }
  },
  computed: {
    ...mapGetters(["showBranding"])
  },
  methods: {
    onLoadImage(e) {
      if (!e?.target) return;

      const {naturalWidth, naturalHeight} = e.target;
      this.isVerticalImg = naturalWidth < naturalHeight;
    },
  }
}
</script>

<style lang="less" scoped>
.nav-button {
  color: var(--color-gray-300);
  background: transparent;
  box-shadow: none;
  font-size: 18px;
  transition: color 0.3s;

  &[disabled] {
    background-color: transparent !important;
    visibility: hidden;
  }

  &:hover:not([disabled]), &:focus:not([disabled]), &:active:not([disabled]) {
    color: var(--accent-color);
  }
}

/deep/ .ant-progress {
  line-height: 0;
}
</style>
